import type { ReactNode } from "react";
import { ToastProvider } from "@a2z/ui-v2";
import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";

/**
 * `@a2z/ui-v2`'s `ToastProvider`, wired to the portal's copy.
 *
 * It exists as its own component because `closeLabel` is a required prop —
 * the library ships no user-facing strings — and `useTranslations` can only be
 * called BELOW `AdminIntlProvider`, which is the component that renders this.
 */
export function AdminToastProvider({ children }: { children: ReactNode }) {
  const t = useTranslations();
  // `admin-toast-viewport` lifts the stack above the phone's floating bottom
  // nav (app/styles.css) — over it, a toast hid the nav's icons.
  return (
    <ToastProvider
      closeLabel={t(keys.common.close)}
      className="admin-toast-viewport"
    >
      {children}
    </ToastProvider>
  );
}
